function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g data-name="Group 1"><path data-name="Rectangle 1" fill="none" d="M0 0h24v24H0z" /><path data-name="Path 2" d="M10.592 0L8.999.719 13.979 12 9 23.281l1.593.719 5.3-12z" fill="currentColor" /></g></svg>;
});